
export const NOT_MET = '#c41149';

export const PARTLY_MET = '#f7bc44';

export const FULLY_MET = '#8abe49';
